import { initAPI } from '@core-ui/api';
import React from 'react';
import Root from './Root';

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
    collapseGroups: true,
    titleColor: 'green',
    diffNameColor: 'darkturquoise',
  });
}

initAPI({
  url: BACKEND_URL
});

Root();
